export default __webpack_public_path__ + "static/media/kanban.main.bg.light.6784442c.svg";